import { render, staticRenderFns } from "./about-footer-menu.vue?vue&type=template&id=482d6e31&scoped=true&"
import script from "./about-footer-menu.vue?vue&type=script&lang=js&"
export * from "./about-footer-menu.vue?vue&type=script&lang=js&"
import style0 from "./about-footer-menu.vue?vue&type=style&index=0&id=482d6e31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d6e31",
  null
  
)

export default component.exports